import { createSelector } from '@reduxjs/toolkit';
import { createOptionBindings } from '@ff-os/pdp-shared-redux/slices/sceneSlice';
import { PhotoPrintsSceneOptions } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsSceneOptions';
import { PhotoPrintsPdpState } from '../store';

const optionsBindings = createOptionBindings<PhotoPrintsSceneOptions, PhotoPrintsPdpState>();
const adapterSelectors = optionsBindings.createEntityOptionSelectors(s => s.sizes);

export const selectAllSizeIds = (state: PhotoPrintsPdpState) => adapterSelectors.selectIds(state) as string[];

export const selectAllSizes = adapterSelectors.selectAll;

export const selectSizeById = adapterSelectors.selectById;

// Selector that returns only accessory sizes
export const selectAccessorySizes = createSelector(
    [selectAllSizes],
    (sizes) => sizes.filter(size => size.isAccessory === true)
);

// Selector to get accessory size by ID
export const selectAccessorySizeById = createSelector(
    [selectAllSizes, (state: PhotoPrintsPdpState, sizeId: string) => sizeId],
    (sizes, sizeId) => sizes.find(size => size.id === sizeId && size.isAccessory === true)
);

export const selectAccessoryMetadataBySizeId = createSelector(
    [selectAccessorySizeById],
    (accessorySize) => {
        if (!accessorySize) return null;

        const baseId = accessorySize.id.match(/^accessories-[^-]+/)?.[0] || accessorySize.id;

        return {
            minimumQuantity: accessorySize?.minimumQuantity ?? 1,
            baseId: baseId,
            name: accessorySize.name,
            label: accessorySize.label
        };
    }
);